<template>
  <div class="changePasswordWrapper">
    <div class="changePasswordCard">
      <h2 class="main-color font-bold changePasswordTitle">{{ $t(localeConsts.title) }}</h2>

      <b-form @submit.prevent="submit">
        <b-form-group :label="$t(localeConsts.currentPassword)">
          <b-form-input
            v-model="currentPassword"
            type="password"
            :placeholder="$t(localeConsts.currentPassword)"
            :state="fieldState('currentPassword')"
            required
          ></b-form-input>
        </b-form-group>

        <b-form-group :label="$t(localeConsts.newPassword)">
          <b-form-input
            v-model="newPassword"
            type="password"
            :placeholder="$t(localeConsts.newPassword)"
            :state="fieldState('newPassword')"
            required
          ></b-form-input>
        </b-form-group>

        <b-form-group :label="$t(localeConsts.confirmPassword)">
          <b-form-input
            v-model="confirmPassword"
            type="password"
            :placeholder="$t(localeConsts.confirmPassword)"
            :state="fieldState('confirmPassword')"
            required
          ></b-form-input>
          <b-form-invalid-feedback>{{ $t(localeConsts.passwordMismatch) }}</b-form-invalid-feedback>
        </b-form-group>

        <div v-if="errorMessage" class="changePasswordError">{{ errorMessage }}</div>

        <div class="changePasswordActions">
          <b-button variant="secondary" @click="$router.back()">{{ $t(localeConsts.cancel) }}</b-button>
          <b-button type="submit" :disabled="isLoading || !isFormValid">
            {{ $t(localeConsts.save) }}
          </b-button>
        </div>
      </b-form>
    </div>
  </div>
</template>

<script>
import axios from '../../../axios'

export default {
  name: 'ChangePassword',
  data() {
    return {
      localeConsts: {
        title: 'CHANGE_PASSWORD.TITLE',
        currentPassword: 'CHANGE_PASSWORD.CURRENT_PASSWORD',
        newPassword: 'CHANGE_PASSWORD.NEW_PASSWORD',
        confirmPassword: 'CHANGE_PASSWORD.CONFIRM_PASSWORD',
        passwordMismatch: 'CHANGE_PASSWORD.PASSWORD_MISMATCH',
        save: 'CHANGE_PASSWORD.SAVE',
        cancel: 'CHANGE_PASSWORD.CANCEL',
        success: 'CHANGE_PASSWORD.SUCCESS',
        errorCurrent: 'CHANGE_PASSWORD.ERROR_CURRENT'
      },
      currentPassword: '',
      newPassword: '',
      confirmPassword: '',
      errorMessage: '',
      submitted: false,
      isLoading: false
    }
  },
  computed: {
    passwordsMatch() {
      return this.newPassword === this.confirmPassword
    },
    isFormValid() {
      return this.currentPassword.length > 0 && this.newPassword.length > 0 && this.passwordsMatch
    }
  },
  methods: {
    fieldState(field) {
      if (!this.submitted) return null
      if (field === 'confirmPassword') return this.passwordsMatch
      return this[field].length > 0
    },
    async submit() {
      this.submitted = true
      this.errorMessage = ''
      if (!this.isFormValid) return

      this.isLoading = true
      try {
        const response = await axios.post('api/user/change-password/', {
          old_password: this.currentPassword,
          new_password: this.newPassword
        })

        // Update stored token since the backend rotates it on password change
        localStorage.setItem('token', response.data.token)
        axios.defaults.headers.common.Authorization = `Token ${response.data.token}`

        this.$bvToast.toast(this.$i18n.t(this.localeConsts.success), {
          variant: 'success',
          autoHideDelay: 3000,
          solid: true
        })

        setTimeout(() => this.$router.push('/dashboard'), 1500)
      } catch (error) {
        if (error.response && error.response.status === 400) {
          this.errorMessage = this.$i18n.t(this.localeConsts.errorCurrent)
        } else {
          this.errorMessage = error.message
        }
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>

<style scoped>
.changePasswordWrapper {
  display: flex;
  justify-content: center;
  padding-top: 40px;
}

.changePasswordCard {
  border: solid 2px rgb(128, 128, 128);
  border-radius: 10px;
  padding: 30px 40px;
  width: 420px;
}

.changePasswordTitle {
  margin-bottom: 24px;
  text-align: center;
}

.changePasswordActions {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}

.changePasswordError {
  color: red;
  text-align: center;
  margin-bottom: 10px;
}
</style>
